// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__m1EYC","is-active":"Tabs_is-active__6Mevd","is-locked":"Tabs_is-locked__moznO","is-disabled":"Tabs_is-disabled__iOuUz"};